<template>
  <div>
    <div
      class="my-2 ml-1"
      v-for="(option, index) in options" :key="index">
      <b-row>
        <b-col class="px-0">
          <b-input-group>
            <b-input-group-prepend
              class="mr-2 flex flexMiddle">
              <span
                v-if="option.label"
                :class="[
                  'optionLabel',
                  'mr-1',
                  `label_${view_template}`
                ]">{{option.label}}</span>
              {{option.prefix}}
            </b-input-group-prepend>
            <!-- テキストと数値 -->
            <b-form-input
              v-if="option.input_type === 1 || option.input_type === 4"
              :disabled="!writable"
              :class="[
                optionData(option.id).errMessages.length > 0 ||
                  (ltTarget(option.id) && !lt)
                  ? 'errItem' : '',
                `template_${option.view_template}`
              ]"
              :maxLength="option.max"
              :value="optionData(option.id).field_answer_text"
              @input="kickSetText($event, option.id)"
              :placeholder="option.placeholder"/>
            <!-- セレクトボックス -->
            <b-form-select
              :disabled="!writable"
              :class="[
                optionData(option.id).errMessages.length > 0 ||
                  (ltTarget(option.id) && !lt)
                  ? 'errItem' : '',
                `template_${option.view_template}`
              ]"
              v-if="option.input_type === 2"
              :value="optionData(option.id).field_answer_id"
              @input="kickSetSelect($event, option.id)"
              :options="option.choice_texts"
              >
                <template v-slot:first>
                  <option :value="null">-- 選択してください。 --</option>
                </template>
              </b-form-select>
            <b-input-group-append
              class="ml-2 flex flexMiddle">
              {{option.suffix}}
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row :class="[
        option.label ? `error_${view_template}` : 'ml-1',
      ]">
        <p class="error my-1"
          v-for="(msg, index) in optionData(option.id).errMessages" :key="index">
          {{msg}}
        </p>
        <p class="error my-1"
          v-show="(ltTarget(option.id) && !lt)">{{ltMsg}}</p>
      </b-row>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PartsApplicationInput',
  props: {
    fieldId: { type: Number },
    notice: {},
    options: {
      type: Array,
      default: () => {
        return [
          {
            id: '',
            label: '',
            // input_type: '',
            prefix: '',
            suffix: '',
            placeholder: '',
            parent_option_id: null,
            parent_choice_id: null,
            view_template: 1,
            max: null,
          },
        ];
      },
    },
    writable: { type: Boolean, default: false },
    view_template: { type: Number, default: 1 },
    rules: { type: [Object, Array], fedault: () => {} },
  },
  data() {
    return {
    };
  },
  methods: {
    kickSetText(value, optionId) {
      const param = {
        field_id: this.fieldId,
        option_id: optionId,
        answer_no: 1, // テキストは当面１つ固定
        value,
      };
      this.$emit('kickSetText', param);
    },
    kickSetSelect(value, optionId) {
      const param = {
        field_id: this.fieldId,
        option_id: optionId,
        answer_no: 1, // テキストは当面１つ固定
        value,
      };
      this.$emit('kickSetSelect', param);
    },
  },
  computed: {
    optionData() {
      const self = this;
      return (optionId) => {
        const { inputs } = this.$store.state.gasApplicationInput;
        const optionData = inputs.find((input) => {
          const sameField = input.field_id === self.fieldId;
          const sameOption = input.option_id === optionId;
          const sameAnswerNo = input.answer_no === 1;
          return sameField && sameOption && sameAnswerNo;
        });
        return optionData;
      };
    },
    lt_column() {
      return this.rules.lt_column;
    },
    sum() {
      let sum = '';
      if (this.rules.lt_column) {
        const optionId = this.rules.lt_column.option_id;
        const { inputs } = this.$store.state.gasApplicationInput;
        sum = 0;
        inputs.forEach((input) => {
          const sameOption = input.option_id === optionId;
          if (sameOption) {
            sum += Number(input.field_answer_text);
          }
        });
      }
      return sum;
    },
    lt() {
      let result = true;
      let targetValue = '';
      if (this.rules.lt_column) {
        const optionId = Number(this.lt_column.params[1].parameter);
        const { inputs } = this.$store.state.gasApplicationInput;
        const targetOption = inputs.find((input) => {
          const sameOption = input.option_id === optionId;
          const sameAnswer = input.answer_no === 1;
          return sameOption && sameAnswer;
        });
        targetValue = Number(targetOption.field_answer_text);
        result = targetValue >= this.sum;
      }
      return result;
    },
    ltTarget() {
      return (optionId) => {
        if (typeof this.lt_column === 'undefined') {
          return false;
        }
        return this.lt_column.option_id === optionId;
      };
    },
    ltMsg() {
      let msg = '';
      if (this.rules.lt_column) {
        const data = this.$store.state.gasApplicationForm.optionDataList;
        // const { fieldLabel, optionLabel } = data[this.lt_column.params[1].parameter];
        const { optionLabel } = data[this.lt_column.params[1].parameter];
        msg = `${optionLabel}以下の値を入力してください。`;
      }
      return msg;
    },
  },
};
</script>

<style scoped>
.errItem {
  border:solid 1px #dc3545 !important;
}
.error {
  font-size: 80%;
  color: #dc3545;
}
input, select {
  height: 50px;
}
.template_1 {
  width: 220px;
  max-width: 220px;
}

.template_2 {
  width: 400px;
  max-width: 400px;
}

.optionLabel.label_1 {
  width: 55px;
}

.optionLabel.label_2 {
  width: 160px;
}

.error_1 {
  margin-left: 60px;
}

.error_2 {
  margin-left: 165px;
}
</style>
